// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Responsive from "react-responsive-decorator";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import BasicSelect from "../../../commons/formElements/basicSelect/basicSelect";
import Modal from "../../../commons/modal/modal";
import styles from "./ticketDashboard.scss";
import { setPageName } from "../../../../services/pageService/pageActionCreator";
import {
  jsonToCSVConvertor,
  navigateToRouteHelper,
  sendGaEvent
} from "../../../../services/helpers";
import {
  getAllTickets,
  getTicketsCount,
  getDashboardTickets,
  getClusterLocationMapping,
  getTicketStatusOptions,
  bulkCloseTickets,
  bulkAssignTickets,
  getSearchOptions
} from "./ticketDashboardRedux/ticketDashboardActionCreator";

import {
  getAllCategories,
  getAllTicketTypes,
  getAssigneeOptions
} from "../createTicket/createTicketRedux/createTicketActionCreator";

import ZoomTable from "../../../commons/zoomTable/zoomTable";

import Loader from "../../../commons/loader/loader";

import {
  pageObj,
  ticketDashboardTabs,
  createTicketRouteObj,
  buSettingsRouteObj,
  categorySettingsRouteObj,
  resolverGroupSettingsRouteObj,
  analyticsEventList,
  severityOptions,
  getSettingsOptions,
  ticketDashboardTableConfig,
  ticketCsvDownloadExtraFields
} from "./ticketDashboardHelper";

import { assigneeTypes } from "../createTicket/createTicketHelper";
import DateRangeFilter from "../../../commons/dateFilter/dateFilter";

type Props = {
  ticketDashboardState: Object,
  setPageName: Function,
  userProfile: Object,
  getAllTickets: Function,
  getTicketsCount: Function,
  getDashboardTickets: Function,
  history: Object,
  getClusterLocationMapping: Function,
  getTicketStatusOptions: Function,
  getAllCategories: Function,
  getAllTicketTypes: Function,
  createTicketState: Object,
  getAssigneeOptions: Function,
  bulkCloseTickets: Function,
  bulkAssignTickets: Function,
  getSearchOptions: Function
};

type State = {
  selectedTab: Object,
  selectedTicketStatus: String,
  locationArrayForApi: Array<any>,
  resetSearchText: boolean,
  ticketStatusOptions: Array<any>,
  settingsPage: Object
};

class TicketDashboard extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.alertMessage = "Nothing to show at the moment";
    this.state = {
      selectedTab: ticketDashboardTabs.assignedToMe,
      resetSearchText: false,
      filters: {
        selectedCategories: [],
        selectedTicketTypes: [],
        selectedStatus: [],
        selectedCluster: null,
        selectedLocations: [],
        pageNumber: 0,
        pageSize: 50,
        selectedSeverity: null,
        settingsPage: null,
        dateFilters: {
          startDate: null,
          endDate: null
        }
      },
      selectedData: [],
      showAssigneeOptions: false,
      assigneeId: null,
      assigneeType: null,
      showReasonForClosureModal: false,
      reasonForClosure: ""
    };
    this.assigneeSearchTimeout = null;
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    this.props.getClusterLocationMapping(
      this.state.selectedTab,
      this.state.filters
    );
    this.props.getTicketStatusOptions();
    const { businessUnitDTO } = this.props.userProfile;
    if (businessUnitDTO) {
      this.props.getAllCategories(businessUnitDTO.id);
      this.props.getAllTicketTypes(businessUnitDTO.id);
    } else {
      this.props.getAllCategories(1); // default
      this.props.getAllTicketTypes(1); // default
    }
    this.props.getSearchOptions();
    this.sendGaEventObject("render");
  }

  componentWillReceiveProps(nextProps) {
    const {
      dashboardTickets,
      bulkClose,
      bulkAssign
    } = nextProps.ticketDashboardState;
    if (dashboardTickets && dashboardTickets.label === "Search") {
      this.setState(
        {
          selectedTab: null
        },
        () => {
          this.sendGaEventObject("header_search", dashboardTickets.key);
        }
      );
    } else if (
      this.props.ticketDashboardState.bulkClose.isLoading &&
      bulkClose.isLoaded &&
      bulkClose.data
    ) {
      if (!bulkClose.data.length) {
        this.setState({
          selectedData: []
        });
      } else {
        this.showBulkActionError("closed", bulkClose.data);
      }
    } else if (
      this.props.ticketDashboardState.bulkAssign.isLoading &&
      bulkAssign.isLoaded &&
      bulkAssign.data
    ) {
      if (!bulkAssign.data.length) {
        this.setState({
          selectedData: []
        });
      } else {
        this.showBulkActionError("assigned", bulkAssign.data);
      }
    }
  }

  onDownloadClick() {
    const columns = [...ticketDashboardTableConfig.columns];
    columns.splice(
      1,
      0,
      ticketCsvDownloadExtraFields.columns[0],
      ticketCsvDownloadExtraFields.columns[1],
      ticketCsvDownloadExtraFields.columns[2]
    );
    jsonToCSVConvertor(
      (this.props.ticketDashboardState.dashboardTickets &&
        this.props.ticketDashboardState.dashboardTickets.data) ||
        [],
      "My Tickets",
      columns
    );
  }

  onChange(val) {
    switch (val) {
      case "buSettings":
        navigateToRouteHelper(buSettingsRouteObj);
        break;
      case "categorySettings":
        navigateToRouteHelper(categorySettingsRouteObj);
        break;
      case "resolverGroupSettings":
        navigateToRouteHelper(resolverGroupSettingsRouteObj);
        break;
      default: {
        this.setState({
          settingsPage: null
        });
      }
    }
  }

  onChangeAssigneeInput(val: String) {
    this.setState(
      {
        showAssigneeOptions: true
      },
      () => {
        if (val && val !== "") {
          if (this.assigneeSearchTimeout != null) {
            clearTimeout(this.assigneeSearchTimeout);
          }
          this.assigneeSearchTimeout = setTimeout(
            this.props.getAssigneeOptions.bind(this, val),
            500
          );
        }
      }
    );
  }

  onReasonForClosureDone() {
    if (this.state.reasonForClosure !== "") {
      this.setState({
        showReasonForClosureModal: false
      });
      const { data } = this.props.ticketDashboardState.clusterLocationMapping;
      const { selectedCluster } = this.state.filters;
      this.props.bulkCloseTickets(
        this.state.selectedData,
        this.state.reasonOfClosure,
        this.state.selectedTab,
        data && selectedCluster && data[selectedCluster.value],
        this.state.filters
      );
    } else {
      const toastrForNoReason = {
        timeOut: 5000,
        component: (
          <div>
            <h2>Error!</h2>
            <h3>Please type a reason for ticket closure</h3>
          </div>
        )
      };
      toastr.error("", toastrForNoReason);
    }
  }

  getAssigneeSelectOptions(assigneeOptions) {
    const tableData = [];
    if (assigneeOptions.data) {
      if (assigneeOptions.data.groupList) {
        assigneeOptions.data.groupList.forEach(user => {
          tableData.push({
            key: user.name,
            val: user.name,
            id: user.id,
            isGroup: true
          });
        });
      }
      if (assigneeOptions.data.userList) {
        assigneeOptions.data.userList.forEach(user => {
          tableData.push({
            key: user.name ? `${user.name} ${user.email}` : user.email,
            val: user.name ? user.name : user.email,
            id: user.id,
            isGroup: false
          });
        });
      }
    }
    return tableData;
  }

  getCategories(data) {
    let categories = [];
    if (data && data.length) {
      categories = data.map(category => ({
        label: category.displayName,
        value: category.id
      }));
    }
    return categories;
  }

  getTicketTypes(data) {
    const ticketTypesObjectToReturn = [];
    if (data && data.length) {
      data.forEach(type => {
        if (
          !(
            this.state.filters.selectedCategories &&
            this.state.filters.selectedCategories.length
          ) ||
          (this.state.filters.selectedCategories &&
            this.state.filters.selectedCategories.length &&
            this.state.filters.selectedCategories.filter(
              category => category.value.toString() === type.option
            ).length)
        ) {
          ticketTypesObjectToReturn.push({
            label: type.key,
            value: type.val
          });
        }
      });
    }
    return ticketTypesObjectToReturn;
  }

  getStatusOptions(data) {
    let statusOptions = [];
    if (data && data.length) {
      statusOptions = data.map(status => ({
        label: status.key.replace("_", " "),
        value: status.val
      }));
    }
    return statusOptions;
  }

  getClusterData(data) {
    let clusters = [];
    if (data) {
      let tempClusters = Object.keys(data);
      tempClusters = tempClusters.sort();
      clusters = tempClusters.map(cluster => ({
        label: cluster,
        value: cluster
      }));
    }
    return clusters;
  }

  getLocationData(data, selectedCluster) {
    let locations = [];
    const locationData = data && selectedCluster && data[selectedCluster];
    if (locationData && locationData.length) {
      locations = locationData.map(location => ({
        label: location,
        value: location
      }));
    }
    return locations;
  }

  fetchData(page) {
    if (page !== undefined && this.state.filters.pageNumber !== page) {
      const newFilters = this.state.filters;
      newFilters.pageNumber = page;
      this.setState(
        {
          filters: newFilters
        },
        () => {
          this.fetchCountAndData();
        }
      );
    }
  }

  changeSelectedTab(tab) {
    const newFilters = this.state.filters;
    newFilters.pageNumber = 0;
    this.setState(
      {
        selectedTab: tab,
        resetSearchText: !this.state.resetSearchText,
        filters: newFilters,
        selectedData: []
      },
      () => {
        this.sendGaEventObject("change_tab", this.state.selectedTab.label);
        this.fetchCountAndData();
      }
    );
  }

  handleFilterChange(key, val) {
    const newFilters = this.state.filters;
    newFilters[key] = val;
    this.setState(
      {
        filters: newFilters
      },
      () => {
        this.fetchCountAndData();
      }
    );
  }

  sendGaEventObject(label, textToAdd) {
    const eventObj = Object.assign({}, analyticsEventList[label]);
    if (textToAdd) {
      eventObj.event_label += textToAdd;
    }
    sendGaEvent(
      eventObj,
      "zoom-panel-ticketing-ticket-dashboard",
      this.props.userProfile
    );
  }

  showToastr() {
    const toastrConfirmOptions = {
      okText: "Confirm",
      title: "Confirmation",
      cancelText: "Cancel",
      transitionIn: "bounceIn",
      transitionOut: "bounceOut",
      onOk: () => {
        const { data } = this.props.ticketDashboardState.clusterLocationMapping;
        const { selectedCluster } = this.state.filters;
        this.props.bulkAssignTickets(
          this.state.selectedData,
          this.state.assigneeType,
          this.state.assigneeId,
          this.state.selectedTab,
          data && selectedCluster && data[selectedCluster.value],
          this.state.filters
        );
      }
    };
    toastr.confirm(
      <div className={styles.toastrMainText}>
        Are you sure you want to change assignee?
      </div>,
      toastrConfirmOptions
    );
  }

  showBulkActionError(text, data) {
    toastr.error(`The following tickets were not ${text}: ${data} `);
  }

  fetchCountAndData() {
    const { data } = this.props.ticketDashboardState.clusterLocationMapping;
    const { selectedCluster } = this.state.filters;
    this.props.getTicketsCount(
      this.state.selectedTab,
      data && selectedCluster && data[selectedCluster.value],
      this.state.filters
    );
  }

  renderTabs() {
    const {
      clusterLocationMapping,
      ticketsCount
    } = this.props.ticketDashboardState;
    if (!clusterLocationMapping.data || ticketsCount.isLoading) {
      return <Loader />;
    }
    return Object.keys(ticketDashboardTabs).map(key => {
      const tab = ticketDashboardTabs[key];
      return (
        <div
          key={tab.label}
          className={
            this.state.selectedTab && this.state.selectedTab.label === tab.label
              ? `${styles.rectangleSelected}`
              : `${styles.rectangle}`
          }
          onClick={() => this.changeSelectedTab(tab)}
        >
          <div className="l-col cursor-p">
            <div className={`${styles.summaryText}`}>{tab.label}</div>
            <div className={`${styles.summaryCount}`}>
              {this.props.ticketDashboardState.ticketsCount.data[
                tab.countAccessor
              ] || 0}
            </div>
          </div>
        </div>
      );
    });
  }

  renderFilter() {
    if (!this.state.selectedTab) {
      return null;
    }
    const {
      clusterLocationMapping,
      ticketStatusOptions
    } = this.props.ticketDashboardState;
    const { assigneeOptions } = this.props.createTicketState;
    const { ticketTypes } = this.props.createTicketState;
    const { categories } = this.props.createTicketState;
    return (
      <div className={`${styles.filterTab} l-row a-center`}>
        <div className={`${styles.filterByText}`}>Filter by </div>
        <Select
          multi
          value={this.state.filters.selectedCategories}
          onChange={val => this.handleFilterChange("selectedCategories", val)}
          options={this.getCategories(categories && categories.data)}
          placeholder="Select Category"
          wrapperStyle={{ width: "20rem", padding: "0.5rem" }}
        />
        <Select
          multi
          value={this.state.filters.selectedTicketTypes}
          onChange={val => this.handleFilterChange("selectedTicketTypes", val)}
          options={this.getTicketTypes(ticketTypes.data)}
          placeholder="Select Ticket types"
          wrapperStyle={{ width: "20rem", padding: "0.5rem" }}
        />
        <Select
          multi
          value={this.state.filters.selectedStatus}
          onChange={val => this.handleFilterChange("selectedStatus", val)}
          options={this.getStatusOptions(ticketStatusOptions.data)}
          placeholder="Select Status"
          wrapperStyle={{ width: "20rem", padding: "0.5rem" }}
        />
        <Select
          value={this.state.filters.selectedSeverity}
          onChange={val => this.handleFilterChange("selectedSeverity", val)}
          options={severityOptions}
          placeholder="Select severity"
          wrapperStyle={{ width: "13rem", padding: "0.5rem" }}
        />
        <DateRangeFilter
          setInitialDateAsNull={true}
          setDateFilter={(startDate, endDate) => {
            if (!startDate && endDate) {
              return;
            }
            if (startDate && !endDate) {
              return;
            }
            this.handleFilterChange("dateFilters", {
              startDate,
              endDate
            });
          }}
          startDate={this.state.filters.startDate} // momentPropTypes.momentObj or null,
          //  startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
          endDate={this.state.filters.endDate} // momentPropTypes.momentObj or null,
          //  endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
          onFocusChange={() => {}} // PropTypes.func.isRequired,/>
        />
        {this.state.selectedTab.label ===
        ticketDashboardTabs.allMyBuTickets.label ? (
          <div className="l-row a-center">
            <Select
              value={this.state.filters.selectedCluster}
              onChange={val => this.handleFilterChange("selectedCluster", val)}
              options={this.getClusterData(clusterLocationMapping.data)}
              placeholder="Select Cluster"
              wrapperStyle={{ width: "12rem", padding: "0.5rem" }}
            />
            <Select
              multi
              value={this.state.filters.selectedLocations}
              onChange={val =>
                this.handleFilterChange("selectedLocations", val)
              }
              options={this.getLocationData(
                clusterLocationMapping.data,
                this.state.filters.selectedCluster &&
                  this.state.filters.selectedCluster.value
              )}
              placeholder="Select locations"
              wrapperStyle={{ width: "20rem", padding: "0.5rem" }}
            />
          </div>
        ) : null}
        {this.state.selectedData && this.state.selectedData.length > 0 ? (
          <div className="l-row a-center">
            <div>
              <div
                className={`${styles.createButton}`}
                onClick={() =>
                  this.setState({ showReasonForClosureModal: true })
                }
              >
                Close Tickets
              </div>
            </div>
            <div className={styles.assigneeInput}>
              <BasicSelect
                label="Select assignee"
                optionsArrOfObj={this.getAssigneeSelectOptions(assigneeOptions)}
                onSelect={(val, event) => {
                  this.setState(
                    {
                      assigneeId: event.id,
                      assigneeType: event.isGroup
                        ? assigneeTypes.GROUP
                        : assigneeTypes.USER,
                      showAssigneeOptions: false
                    },
                    () => {
                      this.showToastr();
                    }
                  );
                }}
                enableSearch={true}
                showOptions={this.state.showAssigneeOptions}
                onChangeInput={val => {
                  this.onChangeAssigneeInput(val);
                }}
              />
            </div>
          </div>
        ) : null}
        <div className="l-row a-center">
          <div>
            <div
              className={`${styles.createButton}`}
              style={{ marginLeft: "10px" }}
              onClick={() => this.onDownloadClick()}
            >
              Download
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReasonForClosureModal() {
    return (
      <Modal
        showModal={this.state.showReasonForClosureModal}
        title="Reason for Closure"
        closeModal={() =>
          this.setState({
            reasonForClosure: "",
            showReasonForClosureModal: false
          })
        }
      >
        <div className={`${styles.reasonForClosureWrapper}`}>
          <div className={`${styles.reasonForClosureText} j-center`}>
            <textarea
              aria-required="true"
              required={true}
              className={styles.escalateModalBodyWrapper}
              onChange={event => {
                this.setState({
                  reasonForClosure: event.target.value
                });
              }}
            />
          </div>
          <div className={`l-row flex-100 ${styles.attachmentConfirmBtn}`}>
            <div
              className={` ${styles.escalateModalBtnWrapper} l-row a-center j-center`}
              onClick={() => this.onReasonForClosureDone()}
            >
              Submit
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderTable() {
    const {
      clusterLocationMapping,
      dashboardTickets,
      ticketsCount
    } = this.props.ticketDashboardState;
    if (
      !clusterLocationMapping.data ||
      dashboardTickets.isLoading ||
      ticketsCount.isLoading
    ) {
      return <Loader />;
    }
    const data = dashboardTickets.data || [];
    if (this.state.selectedTab) {
      const pageSize =
        data.length > this.state.filters.pageSize
          ? this.state.filters.pageSize
          : data.length;
      const totalPages = Math.ceil(
        ticketsCount.data[this.state.selectedTab.countAccessor] /
          this.state.filters.pageSize
      );
      return (
        <div className={`${styles.table}`}>
          <ZoomTable
            paginationProps={{
              showPagination:
                this.state.filters.pageNumber < totalPages && totalPages !== 1,
              onPageChange: page => this.fetchData(page),
              pageSize,
              pageNumber: this.state.filters.pageNumber,
              pages: totalPages,
              serverSidePagination: true
            }}
            onChangeSelection={selectedData =>
              this.setState({
                selectedData
              })
            }
            tableData={data}
            configKey="TICKET_DASHBOARD_KEY"
            tableDataLength={data.length}
            selectionIdAccessor="id"
          />
        </div>
      );
    }
    return (
      <div className={`${styles.table}`}>
        <ZoomTable
          tableData={data}
          configKey="TICKET_DASHBOARD_KEY"
          tableDataLength={data.length}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className={`${styles.upperDivWrapper}`}>
          <div className={`${styles.upperDiv} l-row`}>
            <div className={styles.emptyBox} />
            <div className={`${styles.tabBox} l-row`}>{this.renderTabs()}</div>
            <div className={`${styles.buttonGroup}`}>
              {getSettingsOptions(this.props.userProfile).length ? (
                <div className={`${styles.select}`}>
                  <Select
                    onBlurResetsInput={false}
                    onSelectResetsInput={false}
                    options={getSettingsOptions(this.props.userProfile)}
                    simpleValue
                    clearable={false}
                    name="selected-state"
                    disabled={false}
                    value={this.state.settingsPage}
                    onChange={newValue => this.onChange(newValue)}
                    placeholder="Settings"
                    searchable={false}
                  />
                </div>
              ) : null}
              <div className={styles.emptyBox} />
              <div
                className={`${styles.createButtonSpacing}`}
                onClick={() =>
                  navigateToRouteHelper(createTicketRouteObj, true)
                }
              >
                <div className={`${styles.createButton}`}>Create Ticket</div>
              </div>
              <div
                className={`${styles.createButtonSpacing}`}
                onClick={() =>
                  window.open(
                    "https://s3-ap-southeast-1.amazonaws.com/rivigo-zoom-ticketing-prod/rivigo-zoom-ticketing-prod/training_manual_for_pace/PACE_Manual_and_FAQs.docx",
                    "_blank"
                  )
                }
              >
                <div className={`${styles.createButton}`}>Help</div>
              </div>
            </div>
          </div>
          {this.renderFilter()}
        </div>
        {this.renderTable()}
        {this.renderReasonForClosureModal()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ticketDashboardState: state.ticketDashboardState,
  userProfile: state.userProfile,
  createTicketState: state.createTicketState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getAllTickets: bindActionCreators(getAllTickets, dispatch),
  getTicketsCount: bindActionCreators(getTicketsCount, dispatch),
  getDashboardTickets: bindActionCreators(getDashboardTickets, dispatch),
  getClusterLocationMapping: bindActionCreators(
    getClusterLocationMapping,
    dispatch
  ),
  getTicketStatusOptions: bindActionCreators(getTicketStatusOptions, dispatch),
  getAllCategories: bindActionCreators(getAllCategories, dispatch),
  getAllTicketTypes: bindActionCreators(getAllTicketTypes, dispatch),
  getAssigneeOptions: bindActionCreators(getAssigneeOptions, dispatch),
  bulkCloseTickets: bindActionCreators(bulkCloseTickets, dispatch),
  bulkAssignTickets: bindActionCreators(bulkAssignTickets, dispatch),
  getSearchOptions: bindActionCreators(getSearchOptions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Responsive(TicketDashboard));



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/ticketDashboard/ticketDashboard.js